var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1267 2817 100.215 113.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcd09f;\n      }\n\n      .cls-2 {\n        fill: #b3b3b3;\n      }\n\n      .cls-3 {\n        fill: #f2f2f2;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #ef806f;\n      }\n\n      .cls-6 {\n        fill: gray;\n      }\n\n      .cls-7 {\n        fill: #1ea6c6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-user",
    transform: "translate(1243.245 2817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(42.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-1",
    d: "M114.548,0a23.1,23.1,0,0,1,23,23c0,12.627-10.376,30-23,30s-23-17.373-23-30A23.1,23.1,0,0,1,114.548,0Z",
    transform: "translate(-92.016)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-2",
    d: "M325.868,270.193l-16,16-6-6,17-17A24.8,24.8,0,0,1,325.868,270.193Z",
    transform: "translate(-246.337 -192.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-3",
    d: "M297.879,245.034a24.853,24.853,0,0,1,7,5l-17,17-6-5Z",
    transform: "translate(-230.347 -179.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-4",
    d: "M278.459,316.472l-9,3-9,3,3-9,3-8,6,5Z",
    transform: "translate(-214.927 -222.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-5",
    d: "M260.069,250.964a24.749,24.749,0,1,1-12-12l-16,17-6,17,18-6Z",
    transform: "translate(-180.537 -172.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-6",
    d: "M269.459,343l-9,3,3-9A9.4,9.4,0,0,1,269.459,343Z",
    transform: "translate(-214.927 -245.997)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-7",
    d: "M71.755,229.286c0,5.868.91,10.484,4,15a60.62,60.62,0,0,1-52-15h0c0-16.474,10.056-30.363,24-37,5.241,5.227,10.634,8,17,8s12.757-2.773,18-8a42.11,42.11,0,0,1,12,9C81.384,203.455,71.755,215.311,71.755,229.286Z",
    transform: "translate(0 -140.286)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit-user.a5ee1fff6a60141df1380ae6e19a7c5c.svg";
export { ForwardRef as ReactComponent };